import { restClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

const q = (p: Record<string, unknown>) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== '').reduce((a, [k, v]) => ({ ...a, [k]: String(v) }), {})
).toString()

export const payoutService = {
  trainerPayouts: (p: { page?: number; limit?: number; trainer_id?: number; vendor_id?: number; sort_dir?: string; sorting_by?: string; search?: string } = {}) => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15 }
    if (p.trainer_id) params.trainer_id = p.trainer_id
    if (p.vendor_id) params.vendor_id = p.vendor_id
    if (p.sort_dir) params.sort_dir = p.sort_dir
    if (p.sorting_by) params.sort = p.sorting_by
    if (p.search) params.search = p.search
    return restClient.get(`${endpoints.payouts.trainerPayouts}?${q(params)}`).then(r => r.data)
  },
  schoolPayouts: (p: { page?: number; limit?: number; vendor_id?: number } = {}) => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15 }
    if (p.vendor_id) params.vendor_id = p.vendor_id
    return restClient.get(`${endpoints.payouts.schoolPayouts}?${q(params)}`).then(r => r.data)
  },
  allPayouts: (p: { page?: number; limit?: number; vendor_id?: number; trainer_id?: number } = {}) => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15 }
    if (p.vendor_id) params.vendor_id = p.vendor_id
    if (p.trainer_id) params.trainer_id = p.trainer_id
    return restClient.get(`${endpoints.payouts.getList}?${q(params)}`).then(r => r.data)
  },
  assistantPayouts: (p: { page?: number; limit?: number; assistant_id?: number } = {}) => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15 }
    if (p.assistant_id) params.assistant_id = p.assistant_id
    return restClient.get(`${endpoints.payouts.payoutDetailsAssistant}?${q(params)}`).then(r => r.data)
  },
  payHistory: (p: Record<string, unknown> = {}) => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15, ...p }
    return restClient.get(`${endpoints.payouts.getPayoutHistory}?${q(params)}`).then(r => r.data)
  },
  payByBooking: (p: { page?: number; limit?: number; trainer_id?: string; session_payout_category?: string } = {}) => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15 }
    if (p.trainer_id) params.trainer_id = p.trainer_id
    if (p.session_payout_category) params.session_payout_category = p.session_payout_category
    return restClient.get(`${endpoints.payouts.getPayoutByBooking}?${q(params)}`).then(r => r.data)
  },
  payToTrainer:   (data: Record<string, unknown>) => restClient.post(endpoints.payouts.payToTrainer, data).then(r => r.data),
  payToSchool:    (data: Record<string, unknown>) => restClient.post(endpoints.payouts.payToSchool, data).then(r => r.data),
  payToAssistant: (data: Record<string, unknown>) => restClient.post(endpoints.payouts.payToAssistant, data).then(r => r.data),
}
